export * from '~/sites/oknanebodvere/store/auth'

import { errorFromResponse } from '@/app/notifications'
import { getLoginRedirectPath, actions as parentActions, refreshCartAfterAuth } from '~/sites/oknanebodvere/store/auth'

export const actions = {
  ...parentActions,
  async LOGIN({ dispatch, commit }, options) {
    try {
      const { email, password, redirect, token } = options || {}
      if (token) {
        await dispatch('SET_AUTH', token)
      } else {
        const request = await this.$axios.$post(this.$env.STORE_URL + '/api/oauth/login', {
          email,
          password,
        })
        await dispatch('SET_AUTH', request.data.access_token)
      }
      await dispatch('SET_AXIOS_TOKEN')
      await dispatch('user/FETCH_USER', { forceReload: true }, { root: true })
      commit(
        'globals/ADD_FLASH_MESSAGE',
        { type: 'success', text: this.app.i18n.t('globals.login.successNotificationText') },
        { root: true },
      )
      refreshCartAfterAuth(dispatch)
      await this.app.router.push(getLoginRedirectPath(this.app, redirect))
      return true
    } catch (e) {
      errorFromResponse(e.response)
      return false
    }
  },
}
